export const translationENG = {
    termsOfUse: {
        header: 'Terms and Conditions',
        subheader: 'Review our Universal Terms of Service and End User License Agreement'
    },
    desktopCallback: 'You’re now logged in. Close this tab to continue',
    results: {
        header: 'My results',
        noTestsTakenDescription: 'Complete a test, then check here to see how you performed!',
        myTopScoreHeader: 'MyTopScore™',
        gseScore: 'Overall score',
        viewDetails: 'View Details',
        skillScoresTableHeaders: ['Tests', 'Test ID', 'Date', 'GSE Score', 'CEFR'],
        myTopScoreTableHeaders: [
            'Test',
            'Test ID',
            'Date taken',
            'Speaking',
            'Listening',
            'Reading',
            'Writing',
            'Overall score',
            'CEFR',
            ''
        ],
        resultsTablesHeaders: [
            'Tests',
            'Date',
            'Status',
            'Speaking',
            'Listening',
            'Reading',
            'Writing',
            'Overall score',
            'CEFR',
            ''
        ],
        resultsPracticeTableHeaders: [
            'Tests',
            'Speaking',
            'Listening',
            'Reading',
            'Writing',
            'Overall score',
            ''
        ],
        latestTest: 'Latest test',
        yourSpeakingWasUnscorable: 'Your speaking test was unscorable. Please review the details below',
        somethingWentWrong: 'Something went wrong. For more information and a free retake, please check the test details.',
        unableToCertifyScore: 'Unfortuantely, your score could not be certified.<br /> Please check the test for details.',
        appealBeingReviewed: 'Your appeal is being reviewed by our team. Please check back later to see your final score.',
        testBeingReviewed: 'Your test is being reviewed by our team. Please check back later to see your final score.',
        uploading: 'Your responses are being uploaded in the background. Once all the responses are uploaded the certification process will start.',
        thisTestHasStarted: 'This test is in progress. After the test, you’ll find your score here.',
        testWasNotCompleted: 'This test was exited early. Unfortunately, we can’t provide you with a score.',
        allYourTests: 'All tests',
        allYourPracticeTests: 'All practice tests',
        allResults: 'All results',
        yourTests: 'Tests',
        yourPracticeTests: 'Practice tests',
        resultDetails: 'Result Details',
        expiresIn: 'Expires in: {{daysToExpire}} days',
        expired: 'Expired',
        downloadingAssets: 'Downloading assets',
        resultBadge: {
            certified: 'Certified',
            unscorable: 'Unscorable',
            pendingCertification: 'Pending review',
            unabletoCertify: 'Unable to certify',
            uncertified: 'Uncertified',
            speakingUnscorable: 'Speaking unscorable',
            appealed: 'Appealed',
            started: 'Started',
            incomplete: 'Incomplete',
            uploading: 'Uploading',
            ruleViolation: 'Rule violation',
            inProgress: 'In progress',
            completed: 'Completed',
            error: 'Unable to process',
            lateHangup: 'Late Hangup',
            scoringInProgress: 'Scoring in progress',
            scored: 'Scored',
            actionRequired: 'Action required',
            revoked: 'Revoked'
        },
        reasonsforDeniedCertification: 'Reasons for Denied Certification',
        reason: 'Reason {{number}}',
        skillScores: 'Skill Scores',
        understandingYourSkills: 'Understanding Your skills',
        overallScore: 'Overall score',
        overallScoreDescription: `The Overall score of the test represents the ability to understand spoken English
 and speak it intelligibly at a native-like conversational pace on everyday topics.
 Scores are based on a weighted combination of four diagnostics subscores.`,
        gse: 'GSE',
        gseDescription: 'The Global Scale of English (GSE) is a standardized, granular scale from 10 to 90, which measures English language proficiency. Visit <a>English.com/gse</a> to learn more.',
        mtsDescription: 'To calculate <italic>MyTopScore</italic>, we used the test taker’s best scores in each skill from tests they took in the past 6 months',
        overallDescription: 'The Overall score of the test represents the ability to understand spoken and written English and respond appropriately in speaking and writing on academic and workplace topics, at an appropriate pace and in intelligible English. Scores are reported in the range from 10 to 90 on the GSE.',
        sampleResponses: 'Sample Responses',
        downloadCertificate: 'Download Certificate',
        writingSampleTitle: 'Writing Sample',
        writingSampleText: 'Read a sample from the candidate’s writing test',
        speakingSampleTitle: 'Speaking Sample',
        speakingSampleText: 'Listen to a sample from the candidates speaking test',
        speakingSample: 'Speaking Sample',
        writingSample: 'Writing Sample',
        speakingSkill: 'speaking skill',
        writingSkill: 'writing skill',
        scoreSummary: 'Score Summary',
        viewMyScore: 'View my score',
        viewMyScores: 'View my scores',
        yourScore: 'Your score',
        skillOverwiev: 'Skill Overview',
        tipsAndRecommendations: 'Tips and Recommendations',
        readSample: 'Read Sample',
        listentoSample: 'Listen to sample',
        certificateOverallHeader: 'English Proficiency',
        sampleResponseTitle: '{{firstName}}`s Sample Responses',
        samplePreviewDescription: 'Below is a sample of {{fullName}}`s {{skill}}',
        emailPreview: 'Email preview',
        shareResult: 'Share result',
        shareYourResults: 'Share your results',
        shareYourResultsHeader: 'Who do you want to share your scores with?',
        shareYourResultsDescription: 'When you choose to share the score via the platform, the person you nominate will have access to:',
        shareYourResultsCopyOfCertificate: 'A copy of your certificate',
        shareYourResultsSamples: 'Your speech and writing samples',
        organizationName: 'Organization name',
        specifyOrganization: 'Specify organization',
        emailAddress: 'Email address',
        yourScoreHasBeenSent: 'Your score has been sent to the email you provided. You will get a notification in your email when the score is viewed.',
        yourScoreHasBeenSentToEndCustomer: 'Your score has been sent to ',
        previewTheEmailLinkDescription: 'You can preview the email that you sent by clicking',
        invalidEmailAddress: 'invalid email address',
        previewEmail: 'Preview Email',
        shareResults: 'Share results',
        atLevel: 'At level',
        aboveLevel: 'Above level',
        noTestsDescription: 'After you take a test, you’ll find your scores here',
        belowLevel: 'Below level',
        levelScale: [
            'Below Beginner',
            'Beginner',
            'Elementary',
            'Intermediate',
            'Upper intermediate',
            'Advanced',
            'Mastery'
        ],
        highlightedScores: '*Highlighted scores were used to calculate <span>MyTopScore</span>',
        noResultsText: 'After you take a test, you’ll find your scores here',
        testTakenOn: 'Test taken on',
        shareResultsEmailSentSuccess: 'Success!',
        yourScores: 'Your Scores',
        couldNotBeCertified: 'Your test results could not be certified',
        retakeCompleted: 'This retake has been completed'
    },
    testID: 'Test ID',
    testName: 'Test name',
    shareDetails: {
        sharedWith: 'Shared with',
        sharing: 'Sharing',
        name: 'Name',
        shareDetailsHeaders: ['Test ID', 'Date shared', 'Score', 'Shared with', 'Sharing']
    },
    menuLabels: {
        dashboard: 'Dashboard',
        practice: 'Practice',
        results: 'Results',
        account: 'Account',
        helpCenter: 'Help center',
        testFormats: 'Test Format',
        forInstitutions: 'For Institutions',
        logOut: 'Log out',
        menuTitle: 'PTE Express',
        myAccount: 'My account'
    },
    speaking: 'Speaking',
    listening: 'Listening',
    reading: 'Reading',
    writing: 'Writing',
    dontHaveAnyTests: "You don't have any tests",
    share: 'share',
    rowsPerPage: 'rows per page',
    english: 'English',
    japanese: 'Japanese',
    date: 'Date',
    expirationDate: 'Expiration Date',
    account: {
        dontHaveAnyTestsWithShares: 'After sharing your scores, you’ll find them displayed in this section',
        account: 'Account',
        accounts: 'Accounts',
        off: 'OFF',
        on: 'ON',
        areYouSure: 'Are you sure?',
        yesRevoke: 'Yes, Revoke',
        cancel: 'Cancel'
    },
    pagination: {
        of: 'of'
    },
    view: 'View',
    noSampleTextToPreview: 'There is no sample text to preview.',
    done: 'Done',
    thisShouldBeAValidEmailAddress: 'This should be a valid email address',
    send: 'Send',
    here: 'here',
    success: 'Success',
    score: {
        header: 'Score',
        scoreReportHeader: 'Certificate',
        scores: 'Scores',
        lookup: 'Certificate Lookup'
    },
    play: 'Play',
    exam: {
        speakLabel: 'Speak...',
        listenLabel: 'Listen...',
        fetch: 'Fetch exam'
    },
    layout: {
        next: 'Next',
        back: 'Back',
        agree: 'Agree and proceed'
    },
    directoryLayout: {
        startTest: 'Start Test',
        exitTest: 'Exit Test'
    },
    ageRestriction: {
        title: 'Age restriction',
        thankYouForInterest: `Thank you for your interest. We are sorry to inform you that you are not eligible to use the {{productName}} product due to an age restriction.`,
        pleaseNote: 'Please note that you must be above 14 years to create an account.',
        backToHomepage: 'Back to Homepage'
    },
    signUp: {
        header: 'Sign up',
        mobileHeader: 'Sign up to certify your English',
        description: 'Certify your English with PTE Express',
        shouldBeValidEmail: 'This should be a valid email address',
        withGoogle: 'Continue with Google',
        password: 'Password',
        privacyPolicy: 'Privacy Policy',
        charactersLength: '8 characters',
        consentLabel: 'I have read and agree to the Terms and Conditions and acknowledge the Privacy Policy.',
        offersConsentLabel: 'I am happy to receive personalized offers via email.',
        agreeingText: 'By  signing up, you are agreeing to our',
        cookiePolicy: '<a>Cookie Policy</a>',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign In',
        agreementsDescription: `By continuing, you agree to the <termsOfUseComponent>Terms and Conditions</termsOfUseComponent>
        and <privacyPolicyComponent>Privacy Policy</privacyPolicyComponent>.`,
        termsOfUse: 'Terms and Conditions',
        consentIsMandatory: 'Consent is mandatory',
        agreeToAll: 'I agree to all',
        agreementTitle: 'Consent Confirmation and Privacy Policy Review',
        ageConsent: 'I am at least 14 years old.',
        or: 'or',
        countryOfResidence: 'Country of residence',
        dateOfBirth: 'Date of birth',
        selectDate: 'Select date',
        createAnAccount: 'Create an account',
        createAccount: 'Create account',
        step2Of2: 'Step 2 of 2',
        agreeTermsOfUseAndPrivacyPolicy: 'I agree to the <termsOfUseLink>Terms of Use</termsOfUseLink> and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.*',
        termsAndUseConsent: 'I agree to the <consentLink>Terms and Use</consentLink>.',
        collectPIConsent: 'I agree to the <consentLink>collection and use of my personal information</consentLink>.',
        collectUIIConsent: 'I agree to the collection and use of my Unique Identification Information.',
        collectSIConsent: 'I agree to the collection and use of my Sensitive Information.',
        provisionPIConsent: 'I agree to the <consentLink>provision of my personal information to designated third parties</consentLink>.',
        transferPIConsent: 'I agree to the <consentLink>overseas transfer of my personal information</consentLink>.',
        marketingPurposesConsent: 'I agree to the collection and use of my personal information for marketing purposes.',
        marketingEmailConsent: 'I agree to receive personalised offers and marketing communication via email.',
        ageOrParentalConsent: 'I am above 13 years/my country’s digital consenting age or have my parents/legal guardian’s consent to use this product. *',
        ageOrParentalConsentRequiredError: 'You need to be above 13 years old and have permission from a parent to create an account.',
        requiredError: 'Please accept these policies to proceed.',
        termsAndPrivacyConsent: 'I have read the <termsLink>Terms and Conditions</termsLink> and <privacyLink>Privacy Policy</privacyLink>. *',
        marketingAndOffersEmailConsent: 'I consent to receive marketing mailers; I may unsubscribe at any time.',
        collectUIIConsentTooltip: 'We collect your Unique Identification Information, such as your national ID or passport and a headshot to match your ID, strictly for identity verification to prevent fraud.',
        collectSIConsentTooltip: "We collect your biometric data, including samples of your voice and image, exclusively for identity verification. This prevents fraud by matching the test taker's image and voice to the image and voice of a verified identity. This is vital for conducting the test fairly and securely.",
        provisionPIConsentTooltip: 'We share specific personal information with trusted partners to deliver our service and enhance quality. Please click here for comprehensive details on how your data is used.',
        transferPIConsentTooltip: 'Your data will be transferred to and stored in the USA and accessed globally by Pearson employees as necessary for the provision of services. Please click here for comprehensive details of the transfer of your personal information.',
        marketingPurposesConsentTooltip: 'By agreeing, you allow us to collect and use your personal information exclusively for marketing purposes and to send you tailored updates, promotions and offers from Pearson. You can unsubscribe at any time by clicking the link in your email.',
        countrySpecificPolicies: 'CONSENT CONFIRMATION',
        beforeProceed: 'Before you proceed...',
        differentCountryDetected: 'It looks like you’re in a different country/region. Please agree to the following country-specific Terms & Conditions and Privacy policies'
    },
    verifyYourEmail: {
        title: 'Verify your email',
        titleExpired: 'Verification link expired',
        textLine1: 'We’ve sent a verification link to {{email}}. The link expires in 24 hours.',
        textLine2: 'Didn’t get the email? Check your spam folder, or resend to try again.',
        textExpired: 'For security reasons, the link expired after 24 hours. You’ll need to use a new verification link.',
        action: 'Resend verification email',
        actionSuccess: 'Sent! Check your email for the link.',
        actionExpiredSuccess: 'We’ve sent a new link to {{email}}.',
        pending: 'Resending email',
        emailVerificationSent: 'Sent! Check your email for the link.',
        emailVerifiedTitle: 'Email address verified',
        emailVerifiedDescription: 'You can now log in securely to your account.'
    },
    signIn: {
        header: 'Welcome <br /> back!',
        description: 'Log in to your PTE Express account',
        signUpAndCertify: 'Sign up and certify your level of English proficiency.',
        signInWithGoogle: 'Sign In With Google',
        continueWithGoogle: 'Continue with Google',
        orSignInWith: 'or Sign in with',
        emailOrPasswordErrorMessage: 'The email and/or password you have entered is \nincorrect. Please try again or',
        resetPassword: 'Reset Password.',
        forgotPassword: 'Forgot password?',
        dontHaveAccountYet: "Don't have an account yet?",
        agreeingText: 'By continuing, you are agreeing to our'
    },
    startYourLanguageJourneyHere: 'Start your language journey here',
    join: 'Join',
    signInText: 'Sign in',
    loginInText: 'Log in',
    thisIsRequired: 'This is required',
    invalidEmail: 'Invalid email address',
    email: 'Email',
    fieldIsRequired: 'This field is required',
    password: 'Password',
    signUpText: 'Sign up',
    createAnAccount: 'Create an account',
    watchTheVideo: 'Watch the video',
    resetPassword: {
        header: 'Forgot your <br> password?',
        sendLink: 'Send reset link',
        rememberedPassword: 'Remembered your password?',
        checkYourEmail: 'Check your email for the link',
        sentLinkMessage: `You should soon get an email with a link to reset your password and access your account.`,
        signUpFirst: 'No email from us? We didn’t find an account with that email address. Please try again, or <a>sign up</a> instead.',
        backToSignIn: 'Back to Sign In',
        notToWorryText: `No problem! Enter the email address you used to sign up, and we’ll send you a link to reset your password.`,
        nCharacters: '{{n}} characters',
        confirmPassword: 'Confirm Password',
        passwordsMustBeEqual: 'Password and confirm password must be the same',
        updatePassword: 'Update Password',
        passwordHasBeenUpdated: 'Your password has been updated!',
        signInToAccount: `Sign In to your account with your email and new password below to access your tests,
 scores and profile.`,
        createNewPassword: 'Create a new password',
        settingNewPasswordDescription: 'You can now enter a new password for your account',
        oldPasswordNotMatch: 'Old password does not match!',
        sameOldPassword: 'New password and old password should not be the same!',
        chooseAnotherPassword: 'The password was already used, please choose a different password.'
    },
    atLeast: 'At least',
    oneLowercaseLetter: '1 lowercase letter',
    oneUppercaseLetter: '1 uppercase letter',
    oneNumber: '1 number',
    specialCharacter: '1 special character',
    tellUsMoreForm: {
        getToKnowYou: 'Get to know you',
        tellUsMore: 'Tell us a bit more about yourself',
        preferredName: 'Preferred name',
        fieldRequired: 'This field is required',
        age: 'Age',
        next: 'Next',
        describe: 'Which one best describes you?',
        done: 'You’re all done, thank you!',
        getReady: 'get ready',
        iAmStudent: 'University or post secondary student',
        iAmGraduate: 'I am a graduate',
        iAmYoungProfessional: 'I am a young professional',
        iAmProfessional: 'I am a mid/senior career professional',
        iAmSecondaryStudent: 'I am a secondary student'
    },
    and: 'and',
    changePassword: {
        youCanNowCreate: `You can now create a new password below.`,
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        resetYourPassword: 'Reset your password',
        save: 'Save',
        success: 'Success!',
        passwordChanged: 'Your password has been changed successfully.',
        forgotYourPassword: 'Forgot your password? Not to worry, it happens to all of us! Simply enter your email address below and we’ll send you a reset link.',
        sendLink: 'Send link',
        email: 'Email',
        checkEmail: 'Great! Now check your email',
        weHaveSentLink: 'We have sent you a link to reset your password. Use the link in your email to create a new password and access your account',
        alreadyUsedPasswordError: 'The password was already used, please choose a different password.',
        oldPasswordDoesntMatchError: 'Old password does not match!',
        oldAndNewPasswordsAreEqualError: 'New password and old password should not match!',
        confirmPasswordError: 'Confirmed password and new password are not the same!'
    },
    exploreTestsPage: {
        exploreResources: 'Get ready for the test',
        exploreResourcesButton: 'Explore test resources',
        watchOurWalkthroughs: 'Watch step-by-step videos, check system requirements, or browse frequently asked questions',
        englishSkillsCertificate: 'English Skills Certificate - 4 Skills',
        listeningAndSpeaking: 'Speaking & Listening',
        readingAndWriting: 'Reading & Writing',
        practiceForFree: 'Practice for free',
        checkYourTest: 'Your pre-test checklist',
        takeTest: 'WHAT YOU’LL NEED',
        chooseYourTest: 'Our English tests',
        tagsAll: ['Speaking', 'Listening', 'Reading', 'Writing'],
        tagsListeningSpeaking: ['Speaking', 'Listening'],
        tagsReadingSpeaking: ['Reading', 'Writing'],
        ourEnglishSkillsCertificate: `<bold>{{productName}}™</bold> gives you the flexibility to assess only the English skills that you need to prove.`,
        exploreTestsWrapperTypeOfTestsHeader: 'Certify your English in all 4 skills',
        forSuccessfulTest: 'Before you take a test, make sure you’re all set! Here are our test requirements.',
        checkSystemReq: 'Check system requirements',
        twoSkillsTests: 'or certify 2-skills',
        requirements: {
            system: 'System',
            checkYourSetUp: 'You can perform a ',
            quickSystemCheck: 'quick system check',
            windowOrMacComp: 'Windows or Mac computer',
            speakerOrMicrophone: 'Speakers and microphone',
            reliableInternet: 'Reliable internet',
            security: 'Security',
            governmentId: "Government ID - a passport or driver's licence is preferred",
            singleMonitor: 'A single monitor or display – any extra displays must be disabled',
            frontFacingCamera: 'A front-facing camera',
            environment: 'Environment',
            sixtyMinutes: 'Up to 60 minutes, depending on the test you choose',
            quietWellLit: 'A well-lit space',
            privateSpaceWith: 'Privacy - you’ll need to be alone and uninterrupted'
        },
        min: 'min'
    },
    languageSwitcher: {
        ENG: 'EN',
        JPN: 'JP',
        KOR: 'KO',
        english: 'English',
        japanese: 'Japanese',
        korean: 'Korean'
    },
    takenOn: 'Taken on',
    validThrough: 'Valid through',
    homePage: {
        signup: {
            text: 'Certify your English with PTE Express',
            describe: 'Take a 60-minute online test that’s accepted by US colleges and universities',
            cta: 'Sign up to practice',
            heroImageAlt: 'Signup banner'
        },
        institutionsSection: {
            title: 'Trusted across the United States',
            subtitle: 'To make fair admissions decisions, many leading institutions choose PTE Express to accurately assess students’ English skills',
            buttonText: 'Check where it’s accepted'
        },
        whatIsOdyssey: {
            text: 'What you can expect from the test',
            describe: 'Made for students and universities',
            cta: 'Buy for {{price}}',
            bulletPoints: {
                text0: 'Online, at anytime',
                describe0: '1 hour, computer-based test',
                text1: 'Get results fast',
                describe1: 'Scores immediately after the test, and a certified report in 48 hours',
                text2: 'We’ll share your score with universities for free',
                describe2: 'Select as many universities as you like'
            }
        },
        howdoesitworks: {
            text: 'How will it work?',
            bulletPoints: {
                text0: 'Sign up',
                describe0: 'Then download the computer application',
                text1: 'Take the free practice test',
                describe1: 'Get familiar with the <a>question types</a>',
                text2: 'Ready? Take the test',
                describe2: 'Make sure you’re in a quiet place',
                text3: 'Get your certified score',
                describe3: 'In 48 hours, you’ll have official proof of your English skills'
            }
        },
        bannerSection: {
            title: 'Get early access',
            description: 'Be among the first to take PTE Express later this year. Complete a short form and we’ll notify you as soon as it’s available.',
            getNotified: 'Get notified'
        },
        whyOdyssey: {
            text: 'Your choice for reliability and convenience',
            bulletPoints: {
                text0: 'Top quality at a competitive price',
                describe0: 'Starting from $70, you get test results that demonstrate your true skills.',
                text1: 'Your results, fast!',
                describe1: 'Got a tight admissions deadline? In 48 hours, you can start sharing your score with universities.',
                text2: 'Take it online, at anytime',
                describe2: 'Grab a computer, run the equipment check, then take the test.'
            }
        },
        enterYourEmail: 'Enter your email',
        exploreTests: 'Explore tests',
        exploreResources: 'Explore resources',
        learnAboutTopscore: 'Learn about MyTopScore',
        pearsonTestsAreTrusted: 'Pearson tests are trusted by leading institutions and employers',
        fasterWayToShowEmployers: `{{productName}} is...`,
        featuresOfProduct: {
            fastTitle: 'Fast',
            fastDescription: 'Get your results in minutes, and your shareable certified score within 48 hours',
            convenientTitle: 'Convenient',
            convenientDescription: 'No test center or traveling needed. Take a test online, anywhere, anytime',
            authenticTitle: 'Authentic',
            authenticDescription: 'Evaluate your true English communication skills – not your ability to pass a test'
        }
    },
    institutions: {
        hero: {
            title: 'Accepting institutions',
            subtitle: 'Wondering where you can use your PTE Express results? Our test is recognized by many institutions across the United States, including top universities, colleges, and professional organizations.'
        },
        practice: {
            title: 'Ready to practice?',
            subtitle: 'Get a taste of the PTE Express, and assess your English skills. Try our 30-minute practice test for free.',
            buttonCta: 'Practice the test',
            handbookCta: 'Check the handbook',
            resultBadge: {
                completed: 'Completed',
                incomplete: 'Incomplete'
            }
        },
        institutionsTable: {
            searchPlaceholder: 'Search something...',
            noResults: {
                message: 'We couldn’t find <bold>{{searchTerm}}</bold> in the list, but you can still share it.',
                shareManually: 'Share manually'
            },
            loadingContent: 'Loading institutions...',
            noContentTitle: 'No programs or departments found',
            errorLoadingContent: 'Error loading institutions',
            previousPage: '< Previous',
            nextPage: 'Next >'
        }
    },
    forInstitutions: {
        section: {
            text: 'The online English test you can trust',
            describe: 'Attract more international students with the PTE Express. Offering the convenience of online testing, backed by our expertise in secure and reliable testing. ',
            cta: 'Accept the test'
        },
        whyOdyssey: {
            text: 'Why this test?',
            bulletPoints: {
                text0: 'Reliable results',
                describe0: 'Test takers’ scores reflect their actual English language proficiency.',
                text1: 'Robust security',
                describe1: 'We verify identities, monitor test behavior, and carry out human reviews to ensure tests are valid.',
                text2: 'Global reach',
                describe2: 'Competitively priced at $70, online, and fast. It’s an attractive choice for test takers worldwide.'
            }
        },
        bannerSection: {
            title: 'About the test',
            description: 'This 60-minute test has 12 question types, each evaluating reading, writing, speaking or listening. You can expect a comprehensive assessment of your English language skills.',
            exploreMore: 'Explore each question type'
        },
        fraudSecurity: {
            text: 'Worried about security?',
            describe: 'We use a multi-layered security system that verifies test takers’ identities and deters cheating. After each test, there is human review to ensure that only legitimate test results are certified.',
            section1Title: 'Identity verification measures to prevent proxy testing',
            section2Title: 'Anti-cheating measures in place',
            bulletPoints1: {
                text0: 'Government photo ID or passport required',
                describe0: 'We use technology to extract ID details from official documents',
                text1: 'Facial recognition and monitoring during the test',
                describe1: 'Test takers must stay inside the proctoring window',
                text2: 'Speaker verification',
                describe2: 'Our proprietary system ensures the same voice answers all questions'
            },
            bulletPoints2: {
                text0: 'Dual camera system',
                describe0: 'This ensures appropriate monitoring of test takers’ environments',
                text1: 'Locked test',
                describe1: 'Test takers can’t navigate away from the test application',
                text2: 'Automatic detection and banning of peripheral devices',
                describe2: 'Testing not allowed if headphones or an extra display is connected'
            }
        },
        testInformation: {
            text: 'Scoring and certification',
            bulletPoints: {
                text0: 'Scoring explained',
                describe0: 'Compare our scores to the CEFR levels (A1-C2), and find out how to set your scores',
                exploreMore0: 'View score comparison',
                text1: 'Certified results',
                describe1: 'Get familiar with our certificates, which you’ll be able to validate on the Score Report Website',
                exploreMore1: 'View sample certificate'
            }
        },
        contactSection: {
            title: 'Accept the test',
            description: "Complete a short form and we'll contact you to discuss how your institution can accept PTE Express",
            cta: 'Get started'
        }
    },
    testFormat: {
        section: {
            text: 'Explore the test',
            describe: 'Our 60-minute English test evaluates skills in reading, writing, speaking, and listening. You will find 12 different question types. Learn about them below.'
        },
        bannerSection: {
            title: 'Ready to practice?',
            description: 'Get a taste of the PTE Express, and assess your English skills. Try our 30-minute practice test for free.',
            practice: 'Practice the test'
        },
        testDetails: {
            pills: {
                repeatSentence: 'Repeat the sentence',
                buildSentence: 'Build a sentence',
                listenSelectAnswers: 'Listen and select answers',
                giveYourOpinion: 'Give your opinion',
                writeWhatYouHear: 'Write what you hear',
                summarizeDiscussion: 'Summarize a group discussion',
                readSelectAnswers: 'Read and select answers',
                completeSentence: 'Complete the sentence',
                replyOnlinePost: 'Reply to an online post',
                writeEmail: 'Write an email',
                recordSpeechSample: 'Record a speech sample',
                typeWritingSample: 'Type a writing sample'
            },
            task: 'Task',
            tipsTitle: 'Tips',
            tasks: {
                repeatSentence: [
                    'You will hear a number of sentences',
                    'You will be asked to repeat each one',
                    'You must repeat it exactly as you heard it',
                    'You will have 15 seconds to answer'
                ],
                buildSentence: [
                    'You will hear 3 short phrases',
                    'The phrases will be in a random order',
                    'You must rearrange them into a sentence',
                    'You will have 15 seconds to answer'
                ],
                listenSelectAnswers: [
                    'You will listen to a passage and then answer 2 comprehension questions with multiple-choice options',
                    'Passages are based on authentic sources from academic and workplace contexts, such as interviews, podcasts, conversations, phone messages, and lectures'
                ],
                giveYourOpinion: [
                    'You will hear a question about your opinions or ideas',
                    'You will answer the question with as much detail as you can',
                    'You will hear the question only once',
                    'You will have 40 seconds to answer the question'
                ],
                writeWhatYouHear: [
                    'You will hear a sentence spoken aloud',
                    'You will need to type the sentence word-for-word',
                    'You will only hear the sentence once',
                    'You will have 25 seconds to type your answer'
                ],
                summarizeDiscussion: [
                    'You will hear a short discussion among 3 speakers',
                    'You will summarize what was discussed, in your own words',
                    'Include the main points and important details'
                ],
                readSelectAnswers: [
                    'You will have 3 minutes to read a passage and answer 2 questions',
                    'The passage consists of written material taken from academic and workplace contexts such as article excerpts, narratives, emails, and proposals'
                ],
                completeSentence: [
                    'You will see a sentence or two with a missing word',
                    'You must enter 1 word that best fits the meaning of the sentence',
                    'You will have 25 seconds to answer'
                ],
                replyOnlinePost: [
                    'You will have 3 minutes to read the post and write a reply: write at least 40 words',
                    'The posts are inspired by authentic material from discussion forums in both academic and workplace contexts'
                ],
                writeEmail: [
                    'You will demonstrate your writing ability using email in relatively formal academic and workplace settings',
                    'You must try to fully understand the prompt in order to give an informative, organized, and appropriate response'
                ],
                recordSpeechSample: [
                    'Listen to a question: then, you will have 1 minute to answer the question',
                    'You can start your answer when the recording ends'
                ],
                typeWritingSample: [
                    'Read a question then write your answer',
                    'You will have 2 minutes to answer'
                ]
            },
            tips: {
                repeatSentence: [
                    'Speak smoothly and naturally',
                    'Speak at a normal speed, not too slow or fast',
                    'Try to repeat the sentence exactly as it was spoken'
                ],
                buildSentence: [
                    'Speak smoothly and naturally',
                    'Speak at a normal speed, not too slow or fast',
                    'Be sure to arrange the word groups into the correct order'
                ],
                listenSelectAnswers: [
                    'Before listening to the passage, read the questions',
                    'Try to listen for the correct answers as the passage plays'
                ],
                giveYourOpinion: [
                    'Try to answer the question completely and include details and supporting ideas',
                    'Be sure to use accurate grammar and appropriate word choices',
                    'Speak clearly and fluently so that you can be easily understood'
                ],
                writeWhatYouHear: [
                    'Focus on the meaning of the sentence to help you remember it',
                    'Pay attention to spelling and capitalization'
                ],
                summarizeDiscussion: [
                    'As you listen, try to remember each speaker’s point of view',
                    'Speak clearly using complete sentences, correct grammar, and appropriate vocabulary',
                    'You do not need to memorize or paraphrase the entire discussion, just the most important points'
                ],
                readSelectAnswers: [
                    'Before reading the passage, read the questions',
                    'After you have selected your answers, read the passage again to confirm your selections'
                ],
                completeSentence: [
                    'Consider the overall meaning of the sentence',
                    'Look at the words on either side of the gap and use your knowledge of grammar and vocabulary to choose the missing word',
                    'Pay attention to spelling and capitalization',
                    'There may be more than one correct answer to a question: type the one word that you think best completes the sentence'
                ],
                replyOnlinePost: [
                    'Pay attention to spelling, capitalization, and punctuation',
                    'Write in grammatically correct, complete sentences'
                ],
                writeEmail: [
                    'Pay attention to spelling, capitalization, and punctuation',
                    'Write in grammatically correct, complete sentences',
                    'Read the situation carefully and address your email to the right person',
                    'Cover all three themes in your email, and do not forget to include details to support each idea',
                    'Write at least 100 words',
                    "Do not write informally, nor use texting abbreviations such as 'u'"
                ],
                recordSpeechSample: [
                    'Speak smoothly and naturally',
                    'Speak at a normal speed, not too slow or fast'
                ],
                typeWritingSample: [
                    'Pay attention to spelling, capitalization, and punctuation',
                    'Write in grammatically correct, complete sentences'
                ]
            },
            notScoredSection: '<bold>This section is not scored.</bold>',
            timeLimit: 'Time limit',
            skillsTested: 'Skills tested',
            time: {
                '15sec': '15 sec',
                '2min': '2 min',
                '25sec': '25 sec',
                '40sec': '40 sec',
                '90sec': '90 sec',
                '3min': '3 min',
                '5min': '5 min',
                '9min': '9 min',
                '1min': '1 min'
            },
            skills: {
                speakingListening: 'Speaking, Listening',
                listeningWriting: 'Listening, Writing',
                readingWriting: 'Reading, Writing',
                speaking: 'Speaking',
                writing: 'Writing',
                listening: 'Listening',
                reading: 'Reading'
            }
        }
    },
    allRightsReserved: '© 1996–{{year}} Pearson. All rights reserved.',
    footerLinks: {
        termsOfUse: 'Terms and Conditions',
        privacy: 'Privacy',
        cookies: 'Cookies',
        AOSCT: 'Act on Specified Commercial Transactions'
    },
    generatedOn: 'Generated on',
    skillsLabel: 'Skills',
    myOverallProficiency: 'My Overall Proficiency',
    gseScore: 'GSE score',
    cefrScore: 'CEFR',
    profilePage: {
        close: 'Close',
        profileTab: 'Profile',
        sharedScoresTab: 'Shared scores',
        searchPlaceholder: 'Search',
        allSentScores: 'Scores you’ve shared',
        backToAllSentScores: 'Back to scores you’ve shared',
        turnSharingOff: 'Stop sharing',
        shareDetailsTooltipTitle: `When consent is withdrawn all emails that had access to your scores
 will no longer be able to view your certificate.
 Note that this action cannot be undone.`,
        scoreNotAvailable: 'These scores can no longer be accessed by the receipients you had initially shared them with',
        scoresTableHeaders: ['Organization', 'Email', 'Date shared', 'Status'],
        dateShared: 'Date shared',
        email: 'Email',
        allSentScoresTableHeaders: ['Test name', 'Test ID', 'Score', 'Date generated', 'Shared with'],
        viewed: 'Viewed',
        notViewed: 'Not viewed',
        automaticShareInfoTooltip: 'This score is automatically visible by the organization that invited you to sit this test. You cannot disable sharing in this instance.',
        jitNotice: 'The test has been started and cannot be refunded.',
        downloadReceipt: 'Download receipt',
        paid: 'Paid',
        fulfilled: 'Fulfilled',
        error: 'Error',
        done: 'Done',
        pending: 'Pending',
        denied: 'Denied',
        cancelled: 'Declined',
        accordionHeaders: ['Item', 'Quantity', 'Cost'],
        accordionHeadersShortcut: ['Item', 'Cost'],
        basicInformation: 'Basic information',
        edit: 'Edit',
        demographicDetails: 'Demographic details',
        fullName: 'Full name',
        dateOfBirth: 'Date of birth',
        gender: 'Gender',
        countryOfResidence: 'Country of residence',
        cityOfResidence: 'City',
        citizenship: 'Country of citizenship',
        languages: 'Languages',
        securityAndPrivacy: 'Security & privacy',
        managePasswordHeader: 'Manage password',
        managePreferencesHeader: 'Manage preferences',
        managePreferencesSave: 'Save preferences',
        managePreferencesPersonalInfoHeader: 'Personal information',
        managePreferencesMarketingHeader: 'Marketing communications',
        managePreferencesText: 'Customize your personalized content according to your preferences',
        managePasswordText: 'Change your password',
        privacyPolicyHeader: 'Privacy policy',
        privacyPolicyText: 'Review Pearson Online Products Privacy Policy',
        termsOfUseHeader: 'Terms and Conditions',
        termsOfUseText: 'Review Pearson Online Products Terms and Conditions',
        editProfileTitle: 'Edit your profile information',
        changeYourPassword: 'Change your password',
        editProfileWebTips: '<p><bold>Given name(s):</bold> enter your first, middle and any other names, as they appear on your ID</p> <p><bold>Surname:</bold> enter your surname or family name exactly as it appears on your ID.</p>',
        editProfileFormDescription: "To take the test, you will need a valid photo ID. Please enter your name <bold>exactly</bold> as it appears on your ID. If your ID is not in English, don't worry! Just enter your name in the language of your ID.",
        editProfileFormGivenName: 'Given name(s)',
        editProfileFormGivenNameTooltip: 'Please make sure that your name matches exactly what is in your government issued ID.',
        editProfileFormSurname: 'Surname',
        editProfileFormSurnameTooltip: 'Please make sure that your surname matches exactly what is in your government issued ID.',
        countryOfCitizenship: 'Country of Citizenship',
        countryOfCitizenshipTooltip: 'Please note that your citizenship must match the citizenship in the ID that you will provide during the test.',
        startTypingPlaceholder: 'Start typing ...',
        editProfileFormEmail: 'Email',
        next: 'Next',
        firstLanguage: 'First language',
        scoreSharingHeader: 'Score sharing details',
        sharedWithPeople_zero: '0 people',
        sharedWithPeople_one: '1 person',
        sharedWithPeople_other: '{{count}} people'
    },
    noOptions: 'No options',
    english4SkillsTestName: 'English Certificate | 4-Skills',
    myTopScoreSeparated: 'My Top Score',
    yourTopScoreIsCalculatedFrom: 'Your <boldItalic>myTopScore</boldItalic> is calculated from your top scores in each skill. Take a test to see your best score here!',
    resultsPage: {
        headerTitle: 'Test results',
        learnMoreSectionTitle: 'Understand test scores',
        learnMoreContentTitle: 'What does my Overall Score mean?',
        learnMoreContentText: 'To learn more about your PTE Express score and how it compares to CEFR levels (A1-C2), check out our Score Guide',
        learnMoreButtonText: 'View score guide'
    },
    shareTestResults: {
        header: {
            backButton: 'Back',
            title: 'Share your test results'
        },
        infoBanner: {
            content: 'When you choose to share the score, the institution will have access to your certificate and your video/writing samples'
        },
        institutionsTable: {
            title: 'Choose institutions from the list below to send them your results',
            searchPlaceholder: 'Search something...',
            optionsSelected: '{{count}} options selected',
            share: 'Share',
            sharing: 'Sharing',
            cantFind: 'Can’t find your institution?',
            shareManually: 'Share manually'
        },
        manualShare: {
            title: 'Share your results manually',
            subtitle: 'Enter the institution’s details then share your results',
            name: 'Institution name',
            namePlaceholder: "Enter the institution's name",
            email: 'Institution email',
            emailPlaceholder: "Enter the institution's email address",
            additionalInformation: 'Additional Information',
            optional: '(optional)',
            additionalInformationPlaceholder: 'Add a short message for the institution, for example your program of interest or application details.',
            shareResults: 'Share results',
            success: 'Results shared',
            successTitle: 'Your PTE Express certificate and scores have been shared with:',
            successEmail: 'Email',
            successAdditionalInfo: 'Additional information',
            close: 'Close'
        },
        popUp: {
            success: 'Success',
            title: 'Your certificate and score have been shared with the following {{count}} institutions:',
            button: 'Ok thanks'
        },
        overallScore: {
            title: 'Overall score',
            cefr: 'CEFR:'
        },
        validDates: {
            dateTaken: 'Date taken',
            validUntil: 'Valid until'
        },
        errorMsg: {
            limitOfOptions: 'You can share your score with up to {{limit}} programs each time.',
            failedShare: 'Failed to share results. Please try again.'
        }
    },
    testRecordPage: {
        overallScore: 'Overall score',
        certified: 'Certified',
        cefr: 'CEFR: ',
        backButton: 'Back',
        testTakenOn: 'Test taken on ',
        scoreTotal: '/90',
        shareResultsTitle: 'Share results (recommended)',
        shareResultsContent: 'Officially share your certificate, speaking sample, and writing sample with as many institutions as you like, for free.',
        shareResultsButton: 'Share results',
        downloadCertificateTitle: 'Download your certificate',
        downloadCertificateContent: 'Get a PDF copy of your PTE Express certificate',
        downloadCertificateButton: 'Download certificate',
        nextStepsTitle: 'Next step awaits!',
        nextStepsContent: `Congratulations, your test has been certified! You're now ready to share your results with universities. If you'd like to improve your score, you can purchase a new test.`,
        nextStepsButton: 'Buy a test for {{price}}',
        scoreBreakdown: {
            title: 'Score breakdown',
            content: 'All scores are on a scale of 10 to 90.',
            tips: 'Tips to improve',
            skillExplained: 'Skill explained'
        },
        scoreReportCode: 'Score report code (SRC):',
        overallScoreDescription: 'Here’s your overall score, reflecting your current level across all skills. You can share it with institutions by clicking the button below. Scroll down for a detailed breakdown of each skill, along with personalized tips to help you improve.',
        sharedWithInstitutions: 'Shared with <modalLink>{{count}} institutions</modalLink>',
        sharedWithInstitution: 'Shared with <modalLink>{{count}} institution</modalLink>'
    },
    practicePage: {
        viewPracticeResultsSectionTitle: 'View practice tests results',
        learnMoreSectionTitle: 'Understand practice test results',
        testFormatSectionTitle: 'Test format',
        exploreOurMaterialSectionTitle: 'Explore our prep material',
        testFormatContentTitle: 'Explore each question type',
        learnMoreButtonText: 'Learn more',
        resultBadge: {
            completed: 'Completed',
            incomplete: 'Incomplete'
        },
        testFormatContentDescription: 'Our 60-minute test has 12 question types, each evaluating reading, writing, speaking or listening. You can expect a comprehensive assessment of your English language skills',
        learnMoreTable: {
            overallScore: 'CEFR levels',
            proficiency: 'Score range',
            noviceKey: '<A1 to A1',
            beginnerKey: 'A2 to A2+',
            elementaryKey: 'B1 to B1+',
            upperIntermediateKey: 'B2 to B2+',
            advancedKey: 'C1',
            masteryKey: 'C2',
            noviceValue: '10 to 29',
            beginnerValue: '30 to 42',
            elementaryValue: '43 to 58',
            upperIntermediateValue: '59 to 75',
            advancedValue: '76 to 84',
            masteryValue: '85 to 90'
        },
        learnMoreSection: {
            howToUnderstand: 'How to use your results',
            listItem1: 'You’ll find score ranges (not exact scores) for your overall performance and each skill.',
            listItem2: 'Use these ranges to identify your current level and areas for improvement.',
            listItem3: 'Compare your ranges to the CEFR levels, or check the <scoreGuideLink>Score Guide</scoreGuideLink> for more details.',
            note: 'Note: Institutions require different scores, so make sure to check their websites as well.'
        }
    },
    dashboardPage: {
        dashboardHeaderBanner: {
            welcome: 'Hello!',
            headerText: 'Take a 60-minute online test that’s accepted by US colleges and universities.',
            freePracticeButtonText: 'Try a practice test',
            buyButtonText: 'Buy for {{price}}',
            buyButtonFallback: 'Buy a test',
            testsAvailable_one: '{{count}} test available',
            testsAvailable_other: '{{count}} tests available',
            purchaseProcessing: 'Processing purchase',
            purchaseProcessingTooltip: 'Your order is being processed and should be available in a few seconds.',
            takeTestButtonText: 'Take the test',
            nameOfEnglishTest: 'PTE Express',
            takePracticeTest: 'Free practice',
            testTypes: 'Speaking <bold>•</bold> Listening <bold>•</bold> Reading <bold>•</bold> Writing',
            downloadTheApp: 'Download the app',
            tryPracticeTest: 'Try a practice test',
            timeToPractice: 'Time to practice!',
            getFreeScore: 'Get a free score estimate with our 30-minute practice test.'
        },
        dashboardHeaderAfterTestBanner: {
            welcomeBack: 'Welcome back',
            stepsDescription: 'You are one step away to get your results'
        },
        dashboardHeaderStepper: {
            title: 'Your PTE Express status',
            step: {
                taken: 'Taken',
                scored: 'Scored',
                certified: 'Certified'
            },
            buyNewTest: 'Buy a new test',
            shareResultsNow: 'Share result now'
        },
        statusInfoAccordion: {
            purchased: 'Get ready for your test',
            taken: 'Info about your test',
            scored: 'Info about your test',
            certified: 'Info about your test',
            testStatus: 'Test status',
            title: {
                purchased: 'Did you know you can practice for free?',
                taken: 'What does "Scoring in progress" mean?',
                scored: 'What does "Scored" mean?',
                certified: 'What does "Certified" mean?',
                error: 'What’s happening with my test?'
            },
            description: {
                purchased: 'For preparation materials and a free practice test, be sure to visit the Practice page. It has everything you need to get familiar with PTE Express.',
                taken: 'Your test responses have been submitted successfully and are now being evaluated. Your final score will be ready in just a few minutes.',
                scored: 'Your results are available, but not yet certified. We’re doing a final check, which can take up to 48 hours.',
                certified: 'Your test is now certified! You can view your detailed scores, download your certificate, and share your results with institutions.',
                POTENTIAL_MISCONDUCT: "We couldn't certify your test because some rules weren't followed. Please carefully review the test rules before taking the test again.",
                RULE_VIOLATION: "We couldn't certify your test because of a minor rule issue. This was likely accidental. Please review the rules and take the test again.",
                DEFINITE_MISCONDUCT: 'Your test has been invalidated due to a serious rule violation. Please review the test rules and policies, or contact support for more information.',
                ID_VERIFICATION_PENDING: "<bold>ACTION REQUIRED:</bold> We couldn't verify your identity. Please resubmit a clear photo of your valid ID.",
                CERTIFICATION_REVOKED: '<bold>REVOKED:</bold> We found issues with your previously certified test. If you already shared your results with institutions, they will be informed that your results are no longer valid. For more information, please review our test rules and policies.',
                NOT_SCORED: 'Due to a technical problem during your test session, we couldn’t score your test. Please take the test again.',
                HANG_UP: 'Your test session was ended before you finished the test. Because of this, we unfortunately can’t certify your results. If you would like to try again, you’ll need to buy and take a new test.'
            },
            certificationFailedReasonDetails: '<bold>UNCERTIFIED: {{reasonDetails}}</bold>',
            button: {
                purchased: 'Explore practice resources',
                certified: 'Buy a new test',
                learnMore: 'Learn more',
                BUY_TEST: 'Buy a test',
                TAKE_TEST: 'Retake test',
                SUBMIT_ID: 'Submit ID'
            }
        },
        testNotAvailableForThisDevicePopup: {
            title: 'Not available for this device',
            description: 'Our tests are currently available only on computer. Please try again from a Windows or macOS device.',
            backButton: 'Back to dashboard'
        },
        headerText: 'You’re just a few steps away from getting your <bold>English skills certified!</bold>',
        beforeStartModalSubtitle: 'Practice for free',
        beforeStartModalTitle: 'Before you start',
        beforeStartModalText: 'To take a test, here’s what you need to do:',
        beforeStartModalTextPractice: 'To take a practice test, here’s what you need to do:',
        beforeStartModalText2: 'Ready? Use a computer to download and install the test application.',
        beforeStartModalListItem1: 'Download the test application <bold> (2 min)</bold>',
        beforeStartModalListItem2: 'Set up your test environment <bold> (2 min)</bold>',
        beforeStartModalListItemPractice3: 'Take the practice test <bold> (15 - 30 min)</bold>',
        beforeStartModalListItem3: 'Take the test <bold> (30 - 60 min)</bold>',
        backToDashboard: 'Back to Dashboard',
        retakeTestButton: 'Retake test',
        finalParagraph: 'Ready? Use a computer to download and install the test application.',
        finalParagraphProductName: 'Ready? Use a computer to download and install the <bold>{{productName}}</bold> application.',
        beforeStartModalButton: 'Download application',
        retake: 'Retake',
        SoftProfileAllDoneText: 'To take the test, you will need to download the <bold>application</bold> app on your desktop.',
        softProfileAllDoneDownloadApp: 'Download app',
        SoftProfileAllDoneButton: 'Go to dashboard',
        getReady: 'Get ready',
        youAreAllDone: 'You’re all done, thank you!',
        accordionSubtitle: 'Certify the skills you need to prove',
        accordionPracticeTitle: 'Practice for free',
        accordionPracticeSubtitle: 'Try a practice test',
        accordionTakeTestTitle: 'How to get certified',
        accordionTakeTestButtonText: 'Start test',
        accordionLatestTestResult: 'Latest test: <span>{{score}}</span>',
        expiredLicenseAlert: {
            heading: 'Your test purchase has expired',
            retakeHeading: 'Your free retake is no longer available',
            actionText: 'Learn more',
            message: "It's no longer possible to take the test bought on {{paidAt}}.",
            fallbackMessage: "It's no longer possible to take the test from your previous purchase",
            retakeMessage: 'The 21-day period to retake the test has ended. <learnMore>Learn more</learnMore>'
        },
        accordionShareResultsTitle: 'Share results',
        accordionLatestTestTitle: 'View results',
        takeTestAccordionNoTestsText: 'Buy a test to certify your English skills',
        takeTestAccordionAvailableTestsTitle: 'Available Tests <span>{{availableTests}} test(s)</span>',
        takeTestAccordionSignInButton: 'Browse tests ',
        formDownloadAccordionTitle: 'Before you start',
        formDownloadAccordionSubtitle: 'Take a test',
        formDownloadAccordionPracticeSubtitle: 'Practice for free',
        startJourneyStepperTitle: 'Here’s how it works',
        startJourneyStepperStep1Description: 'Download the computer app <box><bold> 2 min</bold> <downloadLink>Download now</downloadLink></box>',
        startJourneyStepperStep2Description: 'Run the equipment & ID check <bold> 2 min</bold>',
        startJourneyStepperStep3Description: 'Take the test <bold> 60 min</bold>',
        startJourneyStepperStep4Description: 'Get your score in minutes <bold> Certified in 48h</bold>',
        latestTestBoxTitle: 'Latest Test',
        fourSkillsTestTitle: 'English 4 Skills Test',
        practiceSubtitle: 'Practice for free',
        practiceTitle: 'Before you start',
        speakingAndListeningTestTitle: 'Speaking & Listening Test',
        readingAndWritingTestTitle: 'Reading & Writing Test',
        min: 'min',
        resultsAccordionTableHeaders: ['Date taken', 'Status', 'Overall score', 'CEFR', ''],
        practiceResultsAccordionTableHeaders: [
            'Date taken',
            'Status',
            'Speaking',
            'Listening',
            'Reading',
            'Writing',
            'Overall score'
        ],
        practiceTestLabelButtonText: 'Practice',
        productTileButtonText: 'Ready to start',
        identifyIntroSection: {
            whatYouNeed: 'Here’s what you need',
            yourId: 'Official ID with your photo',
            governmentId: 'This is a government-issued ID, such as an identity card or a passport. It must be valid for at least the next 3 months.',
            mobilePhone: 'Smartphone (optional) - recommended',
            weRecommend: 'To take a clear photo of your ID, we recommend using a smartphone instead of your webcam',
            nextPage: 'Next',
            preparePhone: "Prepare your phone: Make sure it's fully charged, connected to the internet (WiFi recommended), and set to 'Do not disturb'.",
            cards: {
                selfieAndVideo: {
                    title: 'Selfie and video',
                    description: 'Using the computer camera'
                },
                photoOfId: {
                    title: 'Photo of official ID',
                    description: 'ID must be valid for at least 3 months'
                },
                secondCamera: {
                    title: '2nd camera setup',
                    description: 'Using a smartphone'
                }
            }
        },
        backToAllResults: 'Back to all results',
        shareScoresDownloadCertificate: 'Share scores/Download certificate',
        startTest: 'Start test',
        downloadScoreCard: 'Download score card',
        buyTest: 'Buy test',
        productTileCounter: '{{items}} items',
        noScore: 'No score',
        takeTestAccordionPendingProductsRefresh: 'Refresh',
        myLatestScore: {
            title: 'Score & Certification',
            text: "Here you'll soon be able to view your final score and access your certification once the full test is available for purchase. Stay tuned for more!",
            notification: 'Coming soon'
        },
        completePracticeTest: {
            title: 'Important',
            text: 'Complete the practice test, then check here to see how you performed'
        },
        purchaseBlockedPopup: {
            locationTitle: 'Test not available',
            locationDescription: "Sorry, we don't offer PTE Express in your country of residence or current location. Alternatively, you may want to try our PTE English tests at a test center.",
            locationAction: 'Explore PTE tests',
            vpnTitle: 'The site can’t be accessed using a VPN connection',
            vpnDescription: 'To ensure accurate access and regional availability, the site can’t be accessed while a VPN connection is active. Please disable your VPN and try again.',
            vpnAction: ''
        }
    },
    faqPage: {
        header: 'Help center',
        headerText: 'Find out how we can can help you in your journey with {{productName}} tests.',
        sidebarText: 'Have another question? <a>Contact Us</a> at any time for assistance.',
        activeCategory: 'About the test',
        categories: 'Categories'
    },
    survey: {
        caption1: 'Terrible',
        caption2: 'Not so great',
        caption3: 'Good',
        caption4: 'Great!',
        caption5: 'Outstanding!!',
        subheader: 'BEFORE YOU GO',
        header: 'Rate your experience',
        headerAlternative: 'Thank you for your feedback!',
        subheader2: 'Tell us how your test experience was',
        textFieldLabel: 'Tell us more',
        button: 'Submit',
        buttonAlternative: 'Go to dashboard',
        reason: {
            subheader: 'SHARE YOUR FEEDBACK',
            header: 'Before you go...',
            subheader2: 'Please let us know what happened:',
            textFieldLabel: `Anything you'd like to share?`
        },
        leaveOnEnvSetup: {
            reason1: 'I had issues with the test setup',
            reason2: "I don't have time to take the test now"
        },
        leaveOnIDVerification: {
            reason1: 'I had issues with the ID verification',
            reason2: "I don't have time to take the test now"
        }
    },
    dateGenerated: 'Date generated',
    sharedWith: 'Shared with',
    testCode: 'Test code',
    testTakerId: 'Test Taker ID',
    stopSharing: 'Stop sharing',
    allSharedScores: 'All shared scores',
    allScoresYouShared: 'All scores you’ve shared',
    doYouWantStopSharing: `Do you want to stop sharing your <bold>{{productNames}}</bold>? By confirming, all the selected contacts that previously received your certificate will lose access to this. You cannot undo this action.`,
    signInPage: {
        haveAccount: 'An account with this email address already exists',
        enterPassword: 'Enter your password to continue.'
    },
    scoreLookup: {
        lookup: 'Certificate lookup',
        description1: 'To access a certificate please enter the information below. If you are having trouble, visit our',
        description2: 'Help Center Page',
        description3: 'for more information.',
        name: 'Test taker name',
        required: 'This field is required',
        org: 'Name of Organization',
        country: 'Country (optional)',
        consent: 'By clicking this box, I confirm that I have been given permission to access the certificate form the test taker.',
        viewCertificate: 'View Certificate',
        byClickingOn: 'By clicking on',
        youAreAgreeing: 'you are agreeing to our',
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'Terms and Conditions',
        cookiePolicy: 'Cookie Policy',
        tooltip: 'We’ll use this data for internal reporting purposes only.',
        expiredDescription: 'Oops, the link has expired and the scores are no longer accessible. Please contact the test taker to request a new link.',
        supportLink: `If you are having trouble, visit the <a>Help Center</a> for more information.`,
        expiredButton: 'Back to Homepage'
    },
    mins: ' mins',
    'No score': 'No score',
    toast: {
        somethingWentWrong: 'Oops! Something went wrong. Please try again',
        sessionExpired: 'Your session has expired. Please log in again.',
        resourceDownloadFailed: 'Failed to download exam resources. Please check your internet connection and try again.'
    },
    mobileUploadId: {
        cameraAccess: 'Camera access required',
        permissionsRequired: 'We need permission to use your camera.',
        permissionsActionDescription: 'Go to your device settings and allow camera access for your browser, then click <bold>Try again</bold> to continue.',
        permissionsPrimaryAction: 'Try again',
        next: 'Next',
        back: 'Back',
        takeAPhoto: 'Take a photo of your ID',
        toBegin: 'To begin, put your ID on a flat, well-lit surface.',
        takePicture: 'Take picture',
        takeAPhotoBack: 'Thank you for submitting a photo of the front of your ID. If you need to submit the back of your ID click on the empty frame.',
        frontAccepted: 'The front of your ID was captured',
        important: 'IMPORTANT',
        importantInfo: 'For any card-style IDs you will need to submit both the front and the back of your ID. For passports, one image only will be sufficient.',
        frontOfId: 'Front of ID',
        use: 'Use',
        tryAgain: 'Try again',
        retry: 'Retry',
        tapToContinue: 'Click the frame below to submit the back of your ID or press Skip to continue.',
        skip: 'Skip Back of ID',
        backCaptured: 'The back of your ID was captured',
        backOfId: 'Back of ID',
        sessionExpired: 'Your session has expired!',
        outOfTime: 'Please head back to the {{productName}} application on your computer to generate a new QR code',
        done: 'Done',
        allDone: 'ID submitted',
        toContinue: 'To continue with the test, head back to the {{productName}} application on your computer',
        thanksForCompleting: 'Thanks for completing the process. You can close this window now.',
        photoDidntMeetRequirements: 'The photo didn’t meet the requirements',
        pleaseTryAgain: 'Please try again. Keep these guidelines in mind when taking photos of your ID.',
        guidelines: 'Photo guidelines',
        missingDetails: 'Missing details',
        blurry: 'Blurry',
        partiallyCovered: 'Partially covered',
        expired: 'Expired',
        clear: 'Clear, full details',
        takeAClearPhoto: 'Please take a <bold>clear photo of your valid ID.</bold> Here are a few examples of photos that will not be accepted.',
        usingPassport: 'If you’re using a passport, skip this step.',
        skipStepPassport: 'Skip',
        guidelinesLink: 'Check photo guidelines',
        frontLineUp: '1. Center your <bold>ID (front) or Passport photo page</bold> in the frame, then take a photo.',
        backLineUp: '2. Now take a photo of the <bold>back of your ID</bold>',
        errorHeader: 'Use a smartphone instead',
        errorDescription: 'This page can’t be accessed from a web browser. To submit your ID, make sure you use a smartphone to scan the QR code.',
        useQrCode: 'Please use your mobile phone to scan the QR code above to continue.',
        alreadySubmittedTitle: 'You have already submitted your ID',
        alreadySubmittedDescription: 'Thank you, there’s nothing left to do here',
        linkOnlyValidFor: 'The link to upload your ID on mobile is only valid for <bold>72 hours</bold>. Please visit the <a>Help Center</a> for additional assistance.',
        linkNotValidAnymore: 'This link is no longer valid',
        left: 'left',
        checkingPhoto: {
            checking: 'Checking your photo…',
            success: 'This photo meets our guidelines',
            retakePhoto: 'Retake photo',
            continue: 'Continue',
            submitPhotos: 'Submit ID photos',
            submittingPhotos: 'Submitting…',
            UNDEREXPOSED: {
                title: 'Not enough light',
                subtitle: 'Please take another photo of your ID. Make sura you are in a well-lit place.'
            },
            OVEREXPOSED: {
                title: 'Too much light',
                subtitle: 'Please take another photo of your ID. Make sure there is not too much light.'
            },
            BLURRY: {
                title: 'Photo is blurry',
                subtitle: 'Please take another photo of your ID.'
            },
            ATTEMPT_LIMIT_EXCEEDED: {
                title: 'Photo guidelines not met',
                subtitle: 'You can continue with the test. We’ll review your ID afterward, but if we can’t verify it, your results may not be valid.'
            },
            LOW_RESOLUTION: {
                title: 'Low resolution photo',
                subtitle: 'Please take another photo of your ID. If possible, try using a different phone.'
            }
        },
        fallback: {
            title: 'Please try again',
            genericSubtitle: 'Something went wrong.',
            action: 'Take photo of ID',
            attemptFailedSubtitle: 'Make sure your whole ID fits in the frame and you’re in a well-lit area.'
        }
    },
    skillsTile: {
        weWereUnable: 'We were unable to certify your scores. Click on <bold>View my scores</bold> below to see score details.'
    },
    testTile: {
        weAreUnable: 'We’re unable to provide you with a score since this test was not completed. Please retake the test for free.',
        ifNeedHelp: 'If you need help, please visit the <a>Help Center</a> page.',
        testId: 'Test ID',
        weCantProvide: 'We can’t provide you with certified test results since the test rules were violated. If you have any questions, please visit our <a>Help Center</a> page.',
        dueToProblem: 'We’re sorry. Due to a problem on our end, we couldn’t provide a score for this test. Please retake the test for free.'
    },
    certificateTypes: {
        readingWriting: 'English Certificate | Reading & Writing',
        speakingListening: 'English Certificate Speaking & Listening'
    },
    clickHereToSubmit: 'Click here to submit the back of your ID or press Skip to continue.',
    webResultsSurvey: {
        certified: {
            upperTitle: 'SHARE YOUR FEEDBACK',
            title: 'How was your test experience?',
            subTitle: 'Congratulations on your certificate! How was your experience with {{productName}}?'
        },
        incomplete: {
            question1: {
                title: 'Tell us what happened with your test',
                option1: 'I no longer wanted to complete the test',
                option2: 'I had a technical issue',
                option3: 'Other (please specify below)'
            },
            question2: "Anything you'd like to share?",
            question3: {
                title: 'Will you retake the test (for free) in the next 5 days?',
                option1: 'Yes',
                option2: 'No'
            }
        },
        uncertified: {
            subTitle: 'Unfortunately, your test could not be certified. Please help us better understand your situation.',
            scaleMinLabel: 'Strongly agree',
            scaleMaxLabel: 'Strongly disagree',
            q1: 'I understand why my test could not be certified',
            q2: 'I know what to do to improve my test conditions',
            q3: 'I plan to take the test again'
        },
        firstPurchase: {
            title: 'How was your purchase experience?',
            subtitle: 'Thanks for buying a test! Please rate your experience.'
        }
    },
    policiesLinks: {
        termsOfUse: 'Terms and Conditions',
        privacyPolicy: 'Privacy Policy',
        actOnSpecifiedCommercial: 'Act on Specified Commercial'
    },
    pageNotFound: {
        title: 'Sorry, we couldn’t find that page',
        description: 'Check if the URL is correct, or try browsing from the homepage',
        button: 'Go to Homepage'
    },
    downloadCertificatePopup: {
        wrapperTitle: 'Download certificate',
        subtitle: 'Select the language you would like to download in below:',
        buttonText: 'Download',
        myTopScore: 'MYTOPSCORE',
        speakingListening: 'SPEAKING & LISTENING',
        readingWriting: 'READING & WRITING',
        languages: {
            eng: 'English',
            jpn: 'Japanese',
            kor: 'Korean'
        }
    },
    oAuthFailed: {
        title: 'Oops, account doesn’t exist',
        subtitle: 'The email you entered does not have an existing account on PTE Express. Please sign up to create an account.'
    },
    AOSCT: {
        title: 'Act on Specified Commercial Transactions',
        subtitle: 'Review our Act on Specified Commercial Transactions below',
        content: {
            1: {
                title: 'Organization name, address, representative name:',
                text: 'Pearson Japan K.K., 11F KANDA SQUARE 2-2-1 Kanda-Nishiki-cho, Chiyoda-ku, Tokyo 101-0054'
            },
            2: {
                title: 'Representative Director,',
                text: 'Yutaka Teranishi'
            },
            3: {
                title: 'Contact Information: (including telephone number, telephone reception time and email address)',
                text: 'Pearson Customer Support',
                text2: '9 am to 5 pm, except Saturdays, Sundays and holidays',
                text3: 'Tel: 03-4540-0380',
                text4: 'E-mail: '
            },
            4: {
                title: 'Selling price: (including the selling price and any other costs such as consumption tax)',
                text: 'Listed at: '
            },
            5: {
                title: 'Payment Method:',
                text: 'The following credit cards are accepted: VISA and MasterCard. Google Pay is also accepted.'
            },
            6: {
                title: 'Payment Deadline:',
                text: 'For credit card payments, the fee will be charged upon completion of the transaction.'
            },
            7: {
                title: 'Time of Service Provision:',
                text: 'Immediately after the transaction.'
            },
            8: {
                title: 'Refund Policy:',
                text: 'You can apply for a refund within 90 days of purchase, provided the test is unused. The refund processing time will depend on your bank.'
            },
            9: {
                title: 'Cancellation Policy:',
                text: 'The same terms as the refund policy apply.'
            }
        }
    },
    mobileCamera: {
        initial: {
            title: 'Set up your 2nd camera',
            text: 'Make sure your mobile device is fully charged or charging, and set to "Do not disturb".',
            buttonText: 'Next'
        },
        connected: {
            title: '2nd camera connected',
            text: 'You can now continue on your computer'
        },
        recording: {
            title: '2nd camera connected',
            text: 'You can now continue on your computer'
        },
        'all-done': {
            title: 'Your test is completed.',
            text: 'You can now close this tab.'
        },
        disconnected: {
            title: 'Your session has ended.',
            text: 'You can restart anytime from the desktop app.'
        },
        expired: {
            title: 'QR code error',
            text: 'Please try scanning the QR code again, or open the link in your mobile browser.',
            buttonText: 'Try again'
        },
        'access-denied': {
            title: 'Camera access required',
            text: 'We need permission to use your camera. To allow access, please change your privacy settings.',
            buttonText: 'Try again'
        },
        'no-mobile': {
            title: 'Use a mobile device instead',
            text: 'To set up your 2nd camera, use a phone or tablet. You can either open the link or scan the QR code shown in the test application.'
        },
        'set-up': {
            title: '2nd camera connected',
            text: 'Place your phone sideways, then follow the steps on your computer'
        },
        recordingOverlayText: 'Streaming in progress...'
    },
    cartWrapper: {
        back: 'Back',
        title: 'Cart',
        allSkills: ['Speaking', 'Listening', 'Reading', 'Writing'],
        proceedToCheckout: 'Proceed to checkout',
        summary: 'Summary',
        couponTitle: 'Got a coupon?',
        enterHere: 'Enter here',
        add: 'Add',
        total: 'Total',
        clear: 'Clear',
        coupon: 'Coupon',
        invalidCoupon: 'This coupon isn’t valid, please try again'
    },
    orderSucceedPage: {
        orderConfirmed: 'Order confirmed',
        thankYouForOrder: 'Thank you for your order!',
        orderNumber: 'Order number',
        summary: 'Summary',
        goToDashboard: 'Go to dashboard',
        total: 'Total',
        coupon: 'Coupon',
        discount: 'Discount',
        tax: 'VAT (or Tax)',
        receipt: 'We’ve sent a receipt to',
        nextStep: "What's next? Head to your dashboard to prepare for your test, or take it at any time."
    },
    appNotInstalled: {
        title: 'Continue in the test application',
        description: 'Don’t have the app yet? Download and install it on your computer to get started.',
        download: 'Download the app',
        close: 'Close'
    },
    resubmitIdPopup: {
        title: 'Check your inbox to continue',
        description1: 'We’ve sent you an email with a QR code. Use a smartphone to scan the code and submit a photo of your ID.',
        description2: 'No email? Check your spam folder or request a new one.',
        resendEmail: 'Resend email'
    },
    completeProfile: {
        form: {
            title: 'Please confirm your ID details',
            requiredFieldMessage: 'This field is required',
            givenName: 'Given name(s)',
            surname: 'Surname',
            email: 'Email',
            dateOfBirth: 'Date of birth',
            countryOfCitizenship: 'Country of citizenship',
            action: 'Confirm'
        },
        age: {
            title: 'You must be at least 13 years old to take this test',
            text: 'Please make sure your date of birth is correct. For more information about age requirements, check our <policiesLink>test rules and policies</policiesLink>.',
            action: 'Back to ID details'
        },
        expired: {
            title: 'Something went wrong',
            text: 'Please refresh the page using the button below. If it doesn’t work, return to the desktop app to restart the test.',
            action: 'Refresh'
        },
        multipleAccounts: {
            title: 'You cannot start a test with a different account',
            text: 'We noticed you already have an account linked to {{email}} For security reasons, we only allow one account per person. <lineBreak /><lineBreak /> For more information, please visit our website.',
            action: 'Learn more'
        }
    },
    accountBlocked: {
        blockedTitle: 'Your account was blocked for security reasons',
        blockedDescription: 'Please review the <helpCenterLink>Help Center</helpCenterLink> for more information.',
        goToHomepage: 'Go to homepage'
    },
    helpCenterPage: {
        header: 'Help center',
        headerText: 'Need help? Start here to get guidance and connect with support',
        categories: 'Categories',
        chatWithUs: 'Chat with us',
        chatDescription: "Pop into our chat and we'll help you out in no time.",
        openChat: 'Open chat',
        createTicket: 'Create a ticket',
        ticketDescription: "Fill out a quick form and we'll get back to you with help.",
        goToForm: 'Go to form'
    },
    taxIncluded: 'Tax included'
};
//# sourceMappingURL=english.js.map